import { DmsActionTypes, AddDmses, ModifyDmses, DeleteDmses } from 'Actions/ActionTypes/dmses';
import { Dms, Id } from 'NSwag/ServerClient/Client.nswag';

export const addDmses = (dmses: Dms[]): AddDmses => ({
    type: DmsActionTypes.AddDmses as DmsActionTypes.AddDmses,
    dmses
});

export const modifyDmses = (dmses: Dms[]): ModifyDmses => ({
    type: DmsActionTypes.ModifyDmses as DmsActionTypes.ModifyDmses,
    dmses
});

export const deleteDmses = (ids: Id[]): DeleteDmses => ({
    type: DmsActionTypes.DeleteDmses as DmsActionTypes.DeleteDmses,
    ids
});

export type DmsAction = ReturnType<typeof addDmses | typeof modifyDmses | typeof deleteDmses>
